import { render, staticRenderFns } from "./AiSlider.vue?vue&type=template&id=630abcb6&scoped=true&"
import script from "./AiSlider.vue?vue&type=script&lang=js&"
export * from "./AiSlider.vue?vue&type=script&lang=js&"
import style0 from "./AiSlider.vue?vue&type=style&index=0&id=630abcb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630abcb6",
  null
  
)

export default component.exports